import { useFlags as useLaunchDarklyFlags } from 'launchdarkly-react-client-sdk';
import { getChangedFlags } from '../utils/getChangedFlags';
import { useLocalStorage } from './useLocalStorage';
const useFeatureFlagManagement = () => {
    const launchDarklyFlags = useLaunchDarklyFlags();
    const [localFlags, setLocalFlags] = useLocalStorage('flags.override', {});
    const currentFlags = Object.assign(Object.assign({}, launchDarklyFlags), localFlags);
    const reset = () => {
        setLocalFlags({});
    };
    const toggleFlags = (keys) => {
        const updatedFlagsDiff = getChangedFlags(launchDarklyFlags, currentFlags, keys);
        setLocalFlags(updatedFlagsDiff);
    };
    const toggleFlag = (key) => {
        toggleFlags([key]);
    };
    return {
        currentFlags,
        localFlags,
        toggleFlag,
        toggleFlags,
        reset,
    };
};
export { useFeatureFlagManagement };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRmVhdHVyZUZsYWdNYW5hZ2VtZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL3VzZUZlYXR1cmVGbGFnTWFuYWdlbWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsUUFBUSxJQUFJLG9CQUFvQixFQUFFLE1BQU0sK0JBQStCLENBQUM7QUFFakYsT0FBTyxFQUFFLGVBQWUsRUFBRSxNQUFNLDBCQUEwQixDQUFDO0FBRTNELE9BQU8sRUFBRSxlQUFlLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUVwRCxNQUFNLHdCQUF3QixHQUFHLEdBQUcsRUFBRTtJQUNwQyxNQUFNLGlCQUFpQixHQUFHLG9CQUFvQixFQUFFLENBQUM7SUFFakQsTUFBTSxDQUFDLFVBQVUsRUFBRSxhQUFhLENBQUMsR0FBRyxlQUFlLENBQ2pELGdCQUFnQixFQUNoQixFQUFFLENBQ0gsQ0FBQztJQUVGLE1BQU0sWUFBWSxtQ0FDYixpQkFBaUIsR0FDakIsVUFBVSxDQUNkLENBQUM7SUFFRixNQUFNLEtBQUssR0FBRyxHQUFHLEVBQUU7UUFDakIsYUFBYSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0lBQ3BCLENBQUMsQ0FBQztJQUVGLE1BQU0sV0FBVyxHQUFHLENBQUMsSUFBYyxFQUFFLEVBQUU7UUFDckMsTUFBTSxnQkFBZ0IsR0FBRyxlQUFlLENBQ3RDLGlCQUFpQixFQUNqQixZQUFZLEVBQ1osSUFBSSxDQUNMLENBQUM7UUFFRixhQUFhLENBQUMsZ0JBQWdCLENBQUMsQ0FBQztJQUNsQyxDQUFDLENBQUM7SUFFRixNQUFNLFVBQVUsR0FBRyxDQUFDLEdBQVcsRUFBRSxFQUFFO1FBQ2pDLFdBQVcsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUM7SUFDckIsQ0FBQyxDQUFDO0lBRUYsT0FBTztRQUNMLFlBQVk7UUFDWixVQUFVO1FBQ1YsVUFBVTtRQUNWLFdBQVc7UUFDWCxLQUFLO0tBQ04sQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLE9BQU8sRUFBRSx3QkFBd0IsRUFBRSxDQUFDIn0=